import React from "react";
import "./About.css";
import "./Hero.css"; // ✅ Import button + line styles from Hero
import "./ButtonOverrides.css";
import { useRef } from "react";
import { Link } from "react-router-dom";

const About: React.FC = () => {
  return (
    <div className="about-section">
      <section className="content">
        <p className="section-label">ABOUT US</p>
        <h2>
          Break out of your routine with
          <br />a global perspective.
        </h2>
        <p className="description">
          Based on collective work and shared knowledge, Architecture-Studio
          aims to favour dialogue and debate, to transform individual knowledge
          into increased creative potential.
        </p>

        {/* Reused Hero-style button */}
        {/* <div className="button-wrapper">
          <span className="line left-line"></span>
          <Link to="/about" className="hero-button">
            ABOUT US
          </Link>
          <span className="line right-line"></span>
        </div> */}

        <p className="section-label" style={{ marginTop: "6rem" }}>
          OUR LATEST PROJECTS
        </p>

        <div className="button-wrapper">
          <span className="line left-line"></span>
          <Link to="/projects" className="hero-button">
            PROJECTS
          </Link>
          <span className="line right-line"></span>
        </div>
      </section>
    </div>
  );
};

export default About;
